module.exports = __webpack_public_path__ + "static/media/recharging-your-battery@2x.839f56bd.png";